import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchSubjectGroupStudents = (subjectGroupId, shouldFetch = true, search = "") => {
	const { loggedIn } = useAuthStore();
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`/subject-groups/${subjectGroupId}/students`, {
			params: search ? { search } : undefined,
		});
		return res.data?.data;
	};

	return useQuery(
		["subject-group-students", subjectGroupId, search],
		() => fetch(),
		{
			...fetchConfig,
			enabled: Boolean(shouldFetch && subjectGroupId && loggedIn),
		}
	);
};

export default useFetchSubjectGroupStudents;
